import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var User;
(function (User) {
    let Flags;
    (function (Flags) {
        Flags[Flags["DISABLE_NOTIFICATION"] = 1] = "DISABLE_NOTIFICATION";
        Flags[Flags["INFO_NOTIFICATION"] = 2] = "INFO_NOTIFICATION";
        Flags[Flags["ALARM_NOTIFICATION"] = 4] = "ALARM_NOTIFICATION";
    })(Flags = User.Flags || (User.Flags = {}));
    function isNotificationsAllowed(user) {
        return !isFlagSet(user, Flags.DISABLE_NOTIFICATION);
    }
    User.isNotificationsAllowed = isNotificationsAllowed;
    function setNotificationsAllowed(user, allowed) {
        return setFlag(user, Flags.DISABLE_NOTIFICATION, !allowed);
    }
    User.setNotificationsAllowed = setNotificationsAllowed;
    function isInfoNotificationsEnabled(user) {
        return isFlagSet(user, Flags.INFO_NOTIFICATION);
    }
    User.isInfoNotificationsEnabled = isInfoNotificationsEnabled;
    function setInfoNotificationsEnabled(user, enabled) {
        return setFlag(user, Flags.INFO_NOTIFICATION, enabled);
    }
    User.setInfoNotificationsEnabled = setInfoNotificationsEnabled;
    function isAlarmNotificationsEnabled(user) {
        return isFlagSet(user, Flags.ALARM_NOTIFICATION);
    }
    User.isAlarmNotificationsEnabled = isAlarmNotificationsEnabled;
    function setAlarmNotificationsEnabled(user, enabled) {
        return setFlag(user, Flags.ALARM_NOTIFICATION, enabled);
    }
    User.setAlarmNotificationsEnabled = setAlarmNotificationsEnabled;
    User.default_object = {
        name: 'Пользователь',
        phone: '',
        key_and_radiotag_list: [],
        role_list: [],
        password: '',
        setting_register: 0,
    };
    User.get = createAccessors(arrayGetSet('users'), User.default_object);
})(User || (User = {}));
